import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { GuidPipe } from "../../../helpers/guidpipe/guidpipe";
import { LocationAddressPipe } from "../location-address-pipe";
import { ServiceSubtitleViewData } from "./service-subtitle.model";

@Component({
  selector: "service-subtitle",
  templateUrl: "service-subtitle.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [GuidPipe, LocationAddressPipe, TranslatePipe],
})
export class ServiceSubtitleComponent {
  protected subscription = input.required<ServiceSubtitleViewData>();

  protected subscriptionId = computed(() => this.subscription().subscriptionId);
  protected owner = computed(() => this.subscription().organisation || this.subscription().customer?.fullname);
  protected locations = computed(() => this.subscription().locations || []);
}
